<template>
  <apexchart
    type="radialBar"
    height="400"
    :series="series"
    :options="chartOptions" />
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'DataDonut',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    labels: {
      type: Array,
      default: () => [],
    },
    series: {
      type: Array,
      default: () => [],
    },
    centerText: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    chartOptions() {
      return {
        labels: this.labels,
        plotOptions: {
          radialBar: {
            dataLabels: {
              showOn: 'always',
              name: {
                show: false,
              },
              value: {
                color: 'var(--v-white-base)',
                fontSize: '30px',
                show: true,
              },
            },
            barLabels: {
              enabled: false,
            },
          },
        },
      };
    },
  },
};
</script>
